import { render, staticRenderFns } from "./ManageZone.vue?vue&type=template&id=84ec4efa&scoped=true&"
import script from "./ManageZone.vue?vue&type=script&lang=js&"
export * from "./ManageZone.vue?vue&type=script&lang=js&"
import style0 from "./ManageZone.vue?vue&type=style&index=0&id=84ec4efa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ec4efa",
  null
  
)

export default component.exports